// ! This object must match the report details fetchType enum or we are going to have probelms.
export const ControllerFetchType = {
    Object: 0,
    List: 1,
}
